import { StyleSheet } from 'react-native';
import { LoadingSize } from './DbLoading.types';

/** 默认常量 */
export const LOADING_CONSTANTS = {
    defaultColor: '#007AFF',
    secondaryColor: 'rgba(0, 122, 255, 0.3)',
    defaultDuration: 1000,
    textGap: 8,
    fontSize: 14,
    textColor: '#666666',
    maskColor: 'rgba(0, 0, 0, 0.5)',
    contentBgColor: 'rgba(0, 0, 0, 0.75)',
    contentBorderRadius: 12,
};

/** 尺寸映射 */
export const SIZE_MAP: Record<string, number> = {
    small: 20,
    medium: 32,
    large: 48,
};

/** 获取数值尺寸 */
export const getNumericSize = (size: LoadingSize): number => {
    if (typeof size === 'number') return size;
    return SIZE_MAP[size] || SIZE_MAP.medium;
};

/** 基础样式 */
export const styles = StyleSheet.create({
    // 内联容器
    container: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    
    // 水平布局
    containerHorizontal: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    
    // 垂直布局
    containerVertical: {
        flexDirection: 'column',
        alignItems: 'center',
    },
    
    // 全屏遮罩
    fullscreenOverlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    
    // 全屏内容容器
    fullscreenContent: {
        backgroundColor: LOADING_CONSTANTS.contentBgColor,
        borderRadius: LOADING_CONSTANTS.contentBorderRadius,
        padding: 24,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 100,
        minHeight: 100,
    },
    
    // 加载文字
    text: {
        fontSize: LOADING_CONSTANTS.fontSize,
        color: LOADING_CONSTANTS.textColor,
    },
    
    // 全屏模式文字
    textFullscreen: {
        color: '#FFFFFF',
    },
    
    // ========== Spinner 样式 ==========
    spinner: {
        borderWidth: 2,
        borderRadius: 100,
    },
    
    // ========== Dots 样式 ==========
    dotsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dot: {
        borderRadius: 100,
        marginHorizontal: 3,
    },
    
    // ========== Pulse 样式 ==========
    pulseContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    pulseCircle: {
        position: 'absolute',
        borderRadius: 100,
    },
    
    // ========== Wave 样式 ==========
    waveContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    waveBar: {
        marginHorizontal: 2,
        borderRadius: 2,
    },
    
    // ========== Bounce 样式 ==========
    bounceContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    bounceBall: {
        borderRadius: 100,
        marginHorizontal: 3,
    },
    
    // ========== Circular 样式 ==========
    circularContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
